<template>
    <div class="panel-body text-center">
        <span v-if="tipo==1">
           <h3> {{texto==undefined ? 'Procesando...':texto}}<i class="fas fa-spinner fa-pulse fa-3x"></i></h3> 
        </span>
        
        <span v-if="tipo==3">
           <h3>  <i class="fas fa-circle-notch fa-spin fa-2x"></i></h3> 
           {{texto==undefined ? 'Procesando...':texto}}
        </span>
        <span v-if="tipo==2">
           <h3> {{texto==undefined ? 'Procesando...':texto}}<i class="fas fa-cog fa-spin fa-3x"></i></h3> 
        </span>
    </div>
</template>
<script>
export default {
    name:'ProcesandoComponent',
    props:['tipo','texto']
}
</script>

